import { Toaster } from "sonner";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideMessage } from "../../store/uiSlice";
import { showToast } from "../../lib/toast";

export function ToastProvider() {
  const dispatch = useDispatch();
  const message = useSelector(state => state.ui.message);

  useEffect(() => {
    if (message) {
      // Show toast with the message based on type
      const toastOptions = {
        onDismiss: () => {
          dispatch(hideMessage());
        },
      };

      switch (message.type) {
        case 'success':
          showToast.success(message.message, toastOptions);
          break;
        case 'error':
          showToast.error(message.message, toastOptions);
          break;
        case 'warning':
          showToast.warning(message.message, toastOptions);
          break;
        default:
          showToast.default(message.message, toastOptions);
          break;
      }
    }
  }, [message, dispatch]);

  return <Toaster />;
} 